// =============================================================================
// Profile Routes  —  /profile
// =============================================================================
// Route registration for the user profile page.
//
// The page is lazy-loaded so it doesn't add to the initial bundle.
// AuthGuard redirects unauthenticated users to the sign-in page.
// DashboardLayout wraps the page with the sidebar and top header.
//
// Related files:
//   src/pages/profile/index.tsx           → page wrapper (fetches /me)
//   src/sections/profile/ProfileView.tsx  → all visual content
//   src/routes/sections/index.tsx         → registers profileRoutes
//   src/routes/paths.ts                   → paths.profile.root = '/profile'
// =============================================================================

import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const ProfilePage = lazy(() => import('../../pages/profile/index'));

// ----------------------------------------------------------------------

export const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <ProfilePage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <ProfilePage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
